export default __webpack_public_path__ + "static/media/office2-afterB-1024w.a8e86ab1.png";